import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/lib/i18n-context";
import { AuthProvider } from "@/lib/auth-context";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import HomePage from "@/pages/HomePage";
import MapPage from "@/pages/MapPage";
import BoothInfoPage from "@/pages/BoothInfoPage";
import SponsorsPage from "@/pages/SponsorsPage";
import RegisterHubPage from "@/pages/RegisterHubPage";
import RegisterFormPage from "@/pages/RegisterFormPage";
import DashboardPage from "@/pages/DashboardPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import GalleryPage from "@/pages/GalleryPage";
import { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentPages";
import TermsPage from "@/pages/TermsPage";
import { SpeechContestInfoPage, StampRallyInfoPage } from "@/pages/InfoPages";

function AppShell() {
  const location = useLocation();
  // CRITICAL: Handle session_id fragment synchronously during render (not useEffect)
  // This must happen BEFORE ProtectedRoute checks auth.
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/booth-info" element={<BoothInfoPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/sponsors" element={<SponsorsPage />} />
          <Route path="/register" element={<RegisterHubPage />} />
          <Route path="/register/:category" element={<ProtectedRoute><RegisterFormPage /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboardPage /></ProtectedRoute>} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/info/speech-contest" element={<SpeechContestInfoPage />} />
          <Route path="/info/stamp-rally" element={<StampRallyInfoPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <AppShell />
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}
